import _defineProperty from "@babel/runtime/helpers/defineProperty";
import * as React from 'react';
import cn from 'classnames';
import { Enum } from '../../../library';
export var tableClasses = {
  MAIN: 'table',
  RESPONSIVE: 'table-responsive'
};
export var TableDivideType = Enum({
  NONE: 'none',
  ALL: 'all',
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal'
});
export var TableCaptionPositionType = Enum({
  TOP_LEFT: 'top-left',
  TOP_CENTER: 'top-center',
  TOP_RIGHT: 'top-right',
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_CENTER: 'bottom-center',
  BOTTOM_RIGHT: 'bottom-right'
});
export var TableHeaderColor = Enum('none', 'light', 'dark');
export var TableRowAlignment = Enum({
  CENTER: 'center',
  TOP: 'top',
  BOTTOM: 'bottom',
  BASELINE: 'baseline'
});
export var Table = function Table(props) {
  var className = cn(tableClasses.MAIN, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
    '-inline': props.isInline
  }, "-".concat(props.density), props.density), '-divide-vert', props.divide === TableDivideType.VERTICAL || props.divide === TableDivideType.ALL), '-divide-horz', props.divide === TableDivideType.HORIZONTAL || props.divide === TableDivideType.ALL), '-striped', props.isStriped), '-bordered', props.isBordered), '-interactive', props.isInteractive), props.className);
  var captionClassName = cn({
    '-top': props.captionPosition === 'top-left' || props.captionPosition === 'top-right' || props.captionPosition === 'top-center',
    '-center': props.captionPosition === 'top-center' || props.captionPosition === 'bottom-center',
    '-right': props.captionPosition === 'top-right' || props.captionPosition === 'bottom-right',
    '-left': props.captionPosition === 'top-left' || props.captionPosition === 'bottom-left'
  });
  var table = React.createElement("table", {
    className: className
  }, props.caption ? React.createElement("caption", {
    className: captionClassName
  }, props.caption) : null, props.children);
  if (props.isResponsive) {
    return React.createElement("div", {
      className: tableClasses.RESPONSIVE
    }, table);
  }
  return table;
};
Table.displayName = 'Table';
Table.defaultProps = {
  captionPosition: TableCaptionPositionType.BOTTOM_LEFT,
  divide: TableDivideType.NONE,
  headerBG: 'none',
  isBordered: false,
  isInline: false,
  isInteractive: false,
  isResponsive: true,
  isStriped: false
};